import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, withCtx as _withCtx, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-6b3fbb23"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "filter-content-wrap"
};
const _hoisted_2 = {
  class: "new-order-filter-header"
};
const _hoisted_3 = {
  class: "flex-list"
};
const _hoisted_4 = {
  class: "flex-left"
};
const _hoisted_5 = {
  class: "form-row"
};
const _hoisted_6 = {
  class: "appListPopover-content"
};
const _hoisted_7 = {
  class: "appListPopover-content-title"
};
const _hoisted_8 = {
  class: "inf-label"
};
const _hoisted_9 = {
  class: "inf-value"
};
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "复制", -1));
const _hoisted_11 = {
  class: "quick-time-group"
};
const _hoisted_12 = ["onClick"];
const _hoisted_13 = {
  class: "form-row"
};
const _hoisted_14 = {
  class: "flex-right"
};
const _hoisted_15 = {
  class: "form-row"
};
import IncomePermissionBadge from '@/components/IncomePermissionBadge.vue';
import dayjs from 'dayjs';
import useFilterHeader from '../../newOrderList/components/useFilterHeader';
import { message } from 'ant-design-vue';
import { ProductSelect } from '@dbt/product-select';
import '@dbt/product-select/dist/style.css';
import { detailFields, searchFields, getAppListInformation, copy } from '@/common';
export default /*#__PURE__*/_defineComponent({
  __name: 'FilterHeader',
  emits: ['filterSubmit', 'changeType'],
  setup(__props, {
    emit
  }) {
    const {
      productSelectRef,
      quickTimeList,
      originFilterForm,
      filterForm,
      datePickerRef,
      changeQuickTime,
      changeApp
    } = useFilterHeader('duplicateList');
    const reshipStatusList = [{
      label: '全部',
      value: null
    }, {
      label: '已复送',
      value: '20'
    }, {
      label: '复送中',
      value: '10'
    }];
    const onFinish = () => {
      var _filterForm$time_rang, _filterForm$time_rang2;
      if (!filterForm.dbtId) {
        return message.warning('请选择产品');
      }
      let params = {};
      params = {
        dbtId: filterForm.dbtId,
        orderUnion: filterForm.orderUnion,
        userIdentityUnion: filterForm.userIdentityUnion
      };
      // 判断结束时间是否大于开始时间31天
      if (filterForm.time_range.length > 0 && dayjs(filterForm.time_range[1]).diff(dayjs(filterForm.time_range[0]), 'day') > 31) {
        message.warning('时间范围不能超过31天,已自动调整为31天');
        // 修改结束时间
        filterForm.time_range[1] = dayjs(filterForm.time_range[0]).add(31, 'day').endOf('day').format('YYYY-MM-DD HH:mm:ss');
      }
      // 判断是否选择了自定义时间
      if (((_filterForm$time_rang = filterForm.time_range[0]) === null || _filterForm$time_rang === void 0 ? void 0 : _filterForm$time_rang.length) === 8) {
        filterForm.time_range[0] = dayjs(filterForm.time_range[0]).format('YYYY-MM-DD') + ' 00:00:00';
      }
      if (((_filterForm$time_rang2 = filterForm.time_range[1]) === null || _filterForm$time_rang2 === void 0 ? void 0 : _filterForm$time_rang2.length) === 8) {
        filterForm.time_range[1] = dayjs(filterForm.time_range[1]).format('YYYY-MM-DD') + ' 23:59:59';
      }
      // 复送状态
      params.reshipStatusList = filterForm.reshipStatus ? [filterForm.reshipStatus] : ['10', '20'];
      // Order creation time
      if (filterForm.time_range.length > 0 && filterForm.query_time === '1') {
        params.preOrderTimeStart = dayjs(filterForm.time_range[0]).format('YYYY-MM-DD HH:mm:ss');
        params.preOrderTimeEnd = dayjs(filterForm.time_range[1]).format('YYYY-MM-DD HH:mm:ss');
      }
      // Payment completion time
      if (filterForm.time_range.length > 0 && filterForm.query_time === '2') {
        params.reshipTimeStart = dayjs(filterForm.time_range[0]).format('YYYY-MM-DD HH:mm:ss');
        params.reshipTimeEnd = dayjs(filterForm.time_range[1]).format('YYYY-MM-DD HH:mm:ss');
      }
      emit('filterSubmit', params);
    }; // 订单列表搜索
    const resetForm = () => {
      Object.keys(filterForm).forEach(key => {
        filterForm[key] = originFilterForm[key];
      });
      datePickerRef.value.timeStart = dayjs('00:00:00', 'HH:mm:ss');
      datePickerRef.value.timeEnd = dayjs('23:59:59', 'HH:mm:ss');
      onFinish();
    }; // 重置搜索
    const changeStartHms = value => {
      filterForm.quick_time = null;
      filterForm.time_range[0] = dayjs(filterForm.time_range[0]).format('YYYYMMDD') + ' ' + value;
    }; // 修改开始时间
    const changeEndHms = value => {
      filterForm.time_range[1] = dayjs(filterForm.time_range[1]).format('YYYYMMDD') + ' ' + value;
    }; // 修改结束时间
    return (_ctx, _cache) => {
      const _component_SvgIcon = _resolveComponent("SvgIcon");
      const _component_a_tooltip = _resolveComponent("a-tooltip");
      const _component_a_form_item = _resolveComponent("a-form-item");
      const _component_a_select_option = _resolveComponent("a-select-option");
      const _component_a_select = _resolveComponent("a-select");
      const _component_DbtDatePicker = _resolveComponent("DbtDatePicker");
      const _component_a_input = _resolveComponent("a-input");
      const _component_a_button = _resolveComponent("a-button");
      const _component_a_form = _resolveComponent("a-form");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_a_form, {
        layout: "inline",
        model: _unref(filterForm),
        onFinish: onFinish
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createVNode(_component_a_form_item, {
          label: "产品名称：",
          name: "dbtId",
          rules: [{
            required: true,
            message: '请选择产品'
          }]
        }, {
          default: _withCtx(() => [_createVNode(_unref(ProductSelect), {
            ref_key: "productSelectRef",
            ref: productSelectRef,
            modelValue: _unref(filterForm).dbtId,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _unref(filterForm).dbtId = $event),
            multiple: false,
            "show-icon": true,
            "show-extra": true,
            "search-fields": _unref(searchFields),
            "max-tag-count": 1,
            "show-detail": true,
            layout: "vertical",
            descriptionField: "filePath",
            width: 200,
            "popup-class-name": "vertical-product-select income-product-popup income-vertical-product-popup",
            placeholder: "请选择",
            detailFields: _unref(detailFields),
            onChange: _unref(changeApp),
            "show-bottom-border": ""
          }, {
            icon: _withCtx(({
              option
            }) => [option.sensitivePermission === true ? (_openBlock(), _createBlock(IncomePermissionBadge, {
              key: 0
            })) : _createCommentVNode("", true)]),
            detail: _withCtx(({
              detail
            }) => [_createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_createVNode(_component_SvgIcon, {
              iconClass: "informationIcon",
              class: "informationIcon"
            }), _createTextVNode(" " + _toDisplayString(detail.label), 1)]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(getAppListInformation)(detail.extData), child => {
              return _openBlock(), _createElementBlock("div", {
                key: child.label,
                class: "inf-line"
              }, [_createElementVNode("div", _hoisted_8, _toDisplayString(child.label) + "：", 1), _createElementVNode("div", _hoisted_9, _toDisplayString(child.value), 1), _createVNode(_component_a_tooltip, {
                placement: "top"
              }, {
                title: _withCtx(() => [_hoisted_10]),
                default: _withCtx(() => [_createVNode(_component_SvgIcon, {
                  iconClass: "copy",
                  class: "dbt-copyIcon",
                  onClick: $event => _unref(copy)(child.value)
                }, null, 8, ["onClick"])]),
                _: 2
              }, 1024)]);
            }), 128))])]),
            _: 1
          }, 8, ["modelValue", "search-fields", "detailFields", "onChange"])]),
          _: 1
        }), _createVNode(_component_a_form_item, {
          label: "查询时间"
        }, {
          default: _withCtx(() => [_createVNode(_component_a_select, {
            value: _unref(filterForm).query_time,
            "onUpdate:value": _cache[1] || (_cache[1] = $event => _unref(filterForm).query_time = $event),
            style: {
              "width": "126px"
            }
          }, {
            default: _withCtx(() => [_createVNode(_component_a_select_option, {
              value: "1"
            }, {
              default: _withCtx(() => [_createTextVNode("订单创建时间")]),
              _: 1
            }), _createVNode(_component_a_select_option, {
              value: "2"
            }, {
              default: _withCtx(() => [_createTextVNode("操作复送时间")]),
              _: 1
            })]),
            _: 1
          }, 8, ["value"])]),
          _: 1
        }), _createVNode(_component_a_form_item, null, {
          default: _withCtx(() => [_createVNode(_component_DbtDatePicker, {
            ref_key: "datePickerRef",
            ref: datePickerRef,
            "show-use-server-time": false,
            "show-header": false,
            "show-dynamic": false,
            "show-quick": false,
            "is-required": "",
            "show-time-range": "",
            startTime: _unref(filterForm).time_range[0],
            "onUpdate:startTime": _cache[2] || (_cache[2] = $event => _unref(filterForm).time_range[0] = $event),
            endTime: _unref(filterForm).time_range[1],
            "onUpdate:endTime": _cache[3] || (_cache[3] = $event => _unref(filterForm).time_range[1] = $event),
            position: "bottomLeft",
            onChangeStartHms: changeStartHms,
            onChangeEndHms: changeEndHms
          }, null, 8, ["startTime", "endTime"])]),
          _: 1
        }), _createVNode(_component_a_form_item, null, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_11, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(quickTimeList), item => {
            return _openBlock(), _createElementBlock("div", {
              key: item.value,
              class: _normalizeClass(["quick-time-item", {
                active: _unref(filterForm).quick_time === item.value
              }]),
              onClick: $event => _unref(changeQuickTime)(item.value)
            }, _toDisplayString(item.label), 11, _hoisted_12);
          }), 128))])]),
          _: 1
        })]), _createElementVNode("div", _hoisted_13, [_createVNode(_component_a_form_item, {
          label: "订单号：",
          name: "orderUnion"
        }, {
          default: _withCtx(() => [_createVNode(_component_a_input, {
            value: _unref(filterForm).orderUnion,
            "onUpdate:value": _cache[4] || (_cache[4] = $event => _unref(filterForm).orderUnion = $event),
            onChange: _cache[5] || (_cache[5] = e => _unref(filterForm).orderUnion = e.target.value.trim()),
            placeholder: "请输入DBT订单号/平台订单号",
            style: {
              "width": "210px"
            }
          }, null, 8, ["value"])]),
          _: 1
        }), _createVNode(_component_a_form_item, {
          label: "用户ID：",
          name: "userIdentityUnion",
          tooltip: "APP产品可用设备ID/访客ID搜索，小游戏可用openid搜索"
        }, {
          default: _withCtx(() => [_createVNode(_component_a_input, {
            value: _unref(filterForm).userIdentityUnion,
            "onUpdate:value": _cache[6] || (_cache[6] = $event => _unref(filterForm).userIdentityUnion = $event),
            onChange: _cache[7] || (_cache[7] = e => _unref(filterForm).userIdentityUnion = e.target.value.trim()),
            placeholder: "请输入访客ID/设备ID/OpenID",
            style: {
              "width": "210px"
            }
          }, null, 8, ["value"])]),
          _: 1
        }), _createVNode(_component_a_form_item, {
          label: "复送状态：",
          name: "reshipStatus"
        }, {
          default: _withCtx(() => [_createVNode(_component_a_select, {
            value: _unref(filterForm).reshipStatus,
            "onUpdate:value": _cache[8] || (_cache[8] = $event => _unref(filterForm).reshipStatus = $event),
            style: {
              "width": "210px"
            },
            placeholder: "全部",
            options: reshipStatusList
          }, null, 8, ["value"])]),
          _: 1
        })])]), _createElementVNode("div", _hoisted_14, [_createElementVNode("div", _hoisted_15, [_createVNode(_component_a_form_item, null, {
          default: _withCtx(() => [_createVNode(_component_a_button, {
            onClick: resetForm
          }, {
            default: _withCtx(() => [_createTextVNode("重置")]),
            _: 1
          }), _createVNode(_component_a_button, {
            style: {
              "margin-left": "10px"
            },
            type: "primary",
            "html-type": "submit"
          }, {
            default: _withCtx(() => [_createTextVNode("搜索")]),
            _: 1
          })]),
          _: 1
        })])])])]),
        _: 1
      }, 8, ["model"])])]);
    };
  }
});